import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';

import type { IBusinessName } from './types';

export default function BusinessName({ disabled }: IBusinessName) {
  const { t } = useTranslation('CreateOrder');

  return (
    <TextField
      required
      disabled={disabled}
      name="businessUser.name"
      label={t('ProductForm.labels.businessName')}
      placeholder={t('ProductForm.placeholders.businessName')}
    />
  );
}
